import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { KnmLateFieldsRemark } from '../../../KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

interface IErknmResultDecisionDocumentProps {
  attachmentsNumber: number;
  className?: string;
  decisionIndex: number;
  formRef: IKnmFormRef | undefined;
  isRequired: boolean;
  isWatchOnly: boolean;
  lateFieldName: string | undefined;
  name: string;
  id: string;
}

export const ErknmResultDecisionDocument = memo(
  ({
    attachmentsNumber,
    className = '',
    decisionIndex,
    formRef,
    isRequired,
    isWatchOnly,
    lateFieldName,
    name,
    id,
  }: IErknmResultDecisionDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={className}>
        <div className="shared-group-label">
          Файл решения
          {lateFieldName && <KnmLateFieldsRemark lateFieldPath={lateFieldName} fieldId={id} />}
          <span className="shared-no-wrap-text">
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={isWatchOnly || attachmentsNumber > 0}
              onClick={openSignModal}
            />
          </span>
        </div>
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const reasonsFieldError = props.errors?.resultDecisions?.[decisionIndex]?.document?.attachments;

            if (reasonsFieldError) {
              return <p className="shared-input-error">Поле не может быть пустым</p>;
            }

            return null;
          }}
        </FormSpy>
        <KnmAttachmentsSigning
          isWatchOnly={isWatchOnly}
          name={name}
          isRequired={isRequired}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
      </div>
    );
  },
);
